/**
 * Sanitizes a filename to only contain alphanumeric characters, hyphens, underscores, and dots
 * Preserves the file extension
 */
export const sanitizeFilename = (filename: string): string => {
  const lastDotIndex = filename.lastIndexOf('.')
  const name = lastDotIndex > 0 ? filename.slice(0, lastDotIndex) : filename
  const extension = lastDotIndex > 0 ? filename.slice(lastDotIndex) : ''

  // Replace any character that's not alphanumeric, hyphen, underscore, or dot with underscore
  const sanitizedName = name.replace(/[^a-zA-ZÀ-ÿ0-9\-_.]/g, '_')

  // Also sanitize the extension (though it's usually safe)
  const sanitizedExtension = extension.replace(/[^a-zA-Z0-9.]/g, '')

  return sanitizedName + sanitizedExtension
}

/**
 * Creates a new File object with a sanitized filename
 */
export const sanitizeFile = (file: File): File => {
  const sanitizedName = sanitizeFilename(file.name)
  return new File([file], sanitizedName, { type: file.type })
}
